import { RouteConstants } from '@/features/router/RouteConstants';
import { PageLayout } from '@/global/components';
import { Button } from '@/lib';
import { DataSourceIDEnum } from '@/models/dataSource';
import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { ExclamationIcon } from '@heroicons/react/solid';
import { useTranslation } from 'react-i18next';

type CreateDataSourceEmptyContentProps = {
  dataSourceId: DataSourceIDEnum;
};

export const CreateDataSourceEmptyContent: FC<CreateDataSourceEmptyContentProps> = ({ dataSourceId }) => {
  const { t } = useTranslation('data_source_edit');
  const history = useHistory();

  const handleGoToCatalog = () => {
    history.replace(`${RouteConstants.dataSources}?catalog`);
  };

  return (
    <PageLayout className='items-center justify-center'>
      <div className='flex w-full max-w-md flex-col items-center gap-6 text-center'>
        <div className='flex size-16 items-center justify-center rounded-full bg-red-100'>
          <ExclamationIcon className='size-8 text-red-600' />
        </div>

        <div>
          <h2 className='text-3xl font-bold text-primary-900'>{t('empty.invalidDataSourceType_title')}</h2>
          <p className='text-sm text-tertiary-600'>{t('empty.invalidDataSourceType_description')}</p>
        </div>

        <div className='rounded-md border border-red-200 bg-red-50 p-3'>
          <p className='text-sm text-red-700'>
            {t('empty.invalidParameter')}: <span className='font-mono font-semibold'>{dataSourceId}</span>
          </p>
        </div>

        <Button onClick={handleGoToCatalog}>{t('empty.goToCatalog')}</Button>
      </div>
    </PageLayout>
  );
};
